import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { IonItem, IonLabel } from '@ionic/react'
import throttle from 'lodash/throttle'

import { XPScoreHeader } from '@/components/atoms/XPScoreHeader'
import { OpenAppStreakComponent } from '@/components/organisms/OpenAppStreakComponent'

import { AccountInfo } from '@/services/account'

interface XPWalletProps {
  accountInfo: AccountInfo
  refetchAccountInfo: () => void
  setIsRefetchActive: (isRefetchActive: boolean) => void
}

export const XPWallet: FC<XPWalletProps> = ({
  accountInfo,
  refetchAccountInfo,
  setIsRefetchActive,
}: XPWalletProps) => {
  const { t } = useTranslation('common')

  const handleScroll = throttle((event) => {
    const scrollTop = event.target.scrollTop
    const isTop = scrollTop === 0
    setIsRefetchActive(isTop)
  }, 200)

  return (
    <div
      className="pt-3 pb-2 h-full overflow-y-auto mx-auto max-w-[40rem]"
      onScroll={handleScroll}
    >
      <IonItem>
        <XPScoreHeader
          xp={accountInfo?.xp}
          badge={accountInfo?.badge}
          multiplier={accountInfo?.multiplier}
        />
      </IonItem>
      <OpenAppStreakComponent refetchAccountInfo={refetchAccountInfo} />
      <IonItem>
        <IonLabel className="ion-text-wrap">
          <div className="text-white font-bold text-lg mb-2">
            {t('XPWallet.whatIsXpQuestion')}
          </div>
          <p className="text-cool-gray-200 text-sm">
            {t('XPWallet.whatIsXpAnswer')}
          </p>
        </IonLabel>
      </IonItem>
    </div>
  )
}
